// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import  { getAuth } from "firebase/auth";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  getFirestore,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";



const firebaseConfig = {
  apiKey: "AIzaSyBILi6r_AxgpLG14S1ogPbUJS0CsU_fcyg",
  authDomain: "vue-rendom-tattoo.firebaseapp.com",
  projectId: "vue-rendom-tattoo",
  storageBucket: "vue-rendom-tattoo.firebasestorage.app",
  messagingSenderId: "965963482686",
  appId: "1:965963482686:web:fd154aeb7e67870611736f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth  = getAuth(app);
const db = getFirestore(app);

const DEFAULT_MUSCLE_EXERCISES = [
  "Appareil pour les quadriceps",
  "Appareil pour les ischio-jambiers",
  "Push-up",
  "Tirade",
  "Dips",
  "Flexion des coudes",
  "Appareil pour les epaules",
  "Appareil pour les abdominaux",
];

function makeEmptySession(sessionNumber, exerciseNames = DEFAULT_MUSCLE_EXERCISES) {
  return {
    sessionNumber,
    date: "",
    warmup: { effort: "", duration: "" },
    cardio: { effort: "", duration: "" },
    flexibility: false,
    exercises: exerciseNames.map((name) => ({
      name,
      charge: "",
      reps: "",
      series: "",
    })),
  };
}

function programmesRef() {
  return collection(db, "programmes");
}

function sessionsRef(programmeId) {
  return collection(db, "programmes", programmeId, "sessions");
}

function sessionDoc(programmeId, sessionId) {
  return doc(db, "programmes", programmeId, "sessions", sessionId);
}

async function creerProgramme(nom, userId = null) {
  const payload = {
    nom,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };

  if (userId) payload.userId = userId;

  const ref = await addDoc(programmesRef(), payload);
  return ref.id;
}

async function recupererSessions(programmeId) {
  const snap = await getDocs(
    query(sessionsRef(programmeId), orderBy("sessionNumber", "asc"))
  );
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

async function sauvegarderSession(programmeId, sessionData, sessionId = null) {
  const { id, ...payload } = sessionData;
  payload.updatedAt = serverTimestamp();
  const targetId = sessionId || id || null;

  if (targetId) {
    await setDoc(sessionDoc(programmeId, targetId), payload, { merge: true });
    return targetId;
  }

  const ref = await addDoc(sessionsRef(programmeId), payload);
  return ref.id;
}

async function ajouterSession(programmeId, exerciseNames = DEFAULT_MUSCLE_EXERCISES) {
  const snap = await getDocs(
    query(sessionsRef(programmeId), orderBy("sessionNumber", "asc"))
  );
  const nextNumber = snap.size + 1;
  const payload = {
    ...makeEmptySession(nextNumber, exerciseNames),
    updatedAt: serverTimestamp(),
  };
  const ref = await addDoc(sessionsRef(programmeId), payload);
  return { id: ref.id, ...payload };
}

async function supprimerSession(programmeId, sessionId) {
  await deleteDoc(sessionDoc(programmeId, sessionId));
  const sessions = await recupererSessions(programmeId);
  await Promise.all(
    sessions
      .sort((a, b) => (a.sessionNumber || 0) - (b.sessionNumber || 0))
      .map((session, index) =>
        updateDoc(sessionDoc(programmeId, session.id), {
          sessionNumber: index + 1,
          updatedAt: serverTimestamp(),
        })
      )
  );
}

export {
  auth,
  db,
  creerProgramme,
  recupererSessions,
  sauvegarderSession,
  ajouterSession,
  supprimerSession,
};

